import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { CommonService } from 'src/app/Services/Common/common.service';
import { CommonGridService } from 'src/app/Services/Common/grid.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
declare var $: any;

@Component({
  selector: 'app-add-asset',
  templateUrl: './add-asset.component.html',
  styleUrls: ['./add-asset.component.css']
})
export class AddAssetComponent implements OnInit {
  @ViewChild('invoiceGrid', { static: false }) invoiceGrid: jqxGridComponent;
  WebAPImasteruri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  EmployeeForm: FormGroup;
  DepartmentList:any;
  PaymentModeList:any;
  BranchList:any;
  GridColumns: any;
  Gridsource: any;
  GridToolBar: any;
  GridAdapter: any;
  today = new Date();
  ouIdComboAddapter: any;
  deletedGridRowList: Array<any> = [];
   constructor(
     private formBuilder: FormBuilder,
     private property: PropertiesService,
     public commonService: CommonService,
     private http: HttpClient,
     private gridService: CommonGridService,
     private datePipe: DatePipe,
     private httpRequestService: HttpRequestService,
     private alert: AlertDialogService,
     private route: ActivatedRoute
   ) { this.createForm(); }
 
   createForm() {
     this.EmployeeForm = this.formBuilder.group({
       EmployeeID: [],
       EmpCode: [],
       FullName: [],
       Email: [],
       Mobile: [],
      
     });
   }
 
   ngOnInit(): void {
     this.GetAssetType();
     this.GridInit();
     this.route.queryParams.subscribe(params => {
      if (params.EmployeeID) {
        this.GetInvoiceData(params.EmployeeID);
        this.GetAssetData(params.EmployeeID);
        this.deletedGridRowList = [];
      }
    });
   }

   GetInvoiceData(TransID) {

    this.GetInvoice(TransID).then((list: any) => {
      // this.EmployeeForm.disable();
      let headerDetails: any;
      // let rateDetails: any;
      headerDetails = list.result.Table;
      // rateDetails = list.result.Table1;

      this.EmployeeForm.get("EmployeeID").setValue(headerDetails[0].EmployeeID);
      this.EmployeeForm.get("EmpCode").setValue(headerDetails[0].EmpCode);
      this.EmployeeForm.get("FullName").setValue(headerDetails[0].FullName);
      this.EmployeeForm.get("Email").setValue(headerDetails[0].Email);
      this.EmployeeForm.get("Mobile").setValue(headerDetails[0].Mobile);
    
      // this.Gridsource.localdata = rateDetails;
      // this.GridAdapter = new jqx.dataAdapter(this.Gridsource);
      // $(".invoiceGrid").jqxGrid('updatebounddata');
      // $(".invoiceGrid").jqxGrid({ disabled: false });

    });

  }

  GetAssetData(TransID) {

    this.GetAsset(TransID).then((list: any) => {
      // this.EmployeeForm.disable();
      let headerDetails: any;
      // let rateDetails: any;
      headerDetails = list.result.Table;
      // rateDetails = list.result.Table1;

    
      this.Gridsource.localdata = headerDetails;
      this.GridAdapter = new jqx.dataAdapter(this.Gridsource);
      $(".invoiceGrid").jqxGrid('updatebounddata');
      $(".invoiceGrid").jqxGrid({ disabled: false });

    });

  }

  GetInvoice(TransID) {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.WebAPImasteruri + "/HR/Get_EmployeeMaster?EmployeeID=" + TransID)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  GetAsset(TransID) {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.WebAPImasteruri + "/Asset/Get_Asset?EmployeeID=" + TransID)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  GridInit() {
    var compScope = this;
    let chargeurl = this.WebAPImasteruri + '/HR/Search_EmployeeMaster';
    let chargeLabelInput1: any;

    this.GridColumns =
      [
        {
          text: 'S.No', width: '3%', editable: false, sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 5px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'TransID', datafield: 'TransID', width: '10%', editable: true, hidden: true },
        { text: 'Inc', datafield: 'Inc', width: '10%', editable: true, hidden: true },
        {
          text: 'Asset Type', datafield: 'AssetTypeID', width: '40%', displayfield: 'AssetTypeIDName', columntype: 'dropdownlist', dropDownWidth: 200,
          createeditor: (row: number, value: any, editor: any): void => {
            editor.jqxDropDownList({
              source: this.ouIdComboAddapter,
              displayMember: 'Label',
              valueMember: 'Value',
            });
           
          }
        },
        { text: 'Brand', datafield: 'Brand', width: '10%', editable: true },
        { text: 'Asset Number', datafield: 'AssetNumber', width: '10%', editable: true },
        { text:  'Issued Date', datafield: 'IssuedDate', width: '12%', editable: true, hidden: false, cellsformat: 'dd/MM/yyyy', columntype: 'datetimeinput',class:"form-control" },
        {
          text: 'Issued By', width: '15%', datafield: 'IssuedByName', columntype: 'custom',
          createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
            chargeLabelInput1 = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, chargeurl, 'IssuedByName', undefined, function (obj) {
              // $(".invoiceGrid").jqxGrid('setcellvalue', row, 'RelationshipID', obj.Value);
              
            });
          },
          initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
            this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, chargeLabelInput1);
          },
          geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
            return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.invoiceGrid, 'IssuedBy', chargeLabelInput1);
          },
         
        },
        { text: 'IssuedBy', datafield: 'IssuedBy', width: '10%', editable: true, hidden: true },
        { text:  'Handed Over', datafield: 'HandedOver', width: '12%', editable: true, hidden: false, cellsformat: 'dd/MM/yyyy', columntype: 'datetimeinput',class:"form-control" },
        {
          text: 'Received By', width: '15%', datafield: 'ReceivedByName', columntype: 'custom',
          createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
            chargeLabelInput1 = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, chargeurl, 'ReceivedByName', undefined, function (obj) {
              // $(".invoiceGrid").jqxGrid('setcellvalue', row, 'RelationshipID', obj.Value);
              
            });
          },
          initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
            this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, chargeLabelInput1);
          },
          geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
            return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.invoiceGrid, 'ReceivedBy', chargeLabelInput1);
          },
         
        },
        { text: 'ReceivedBy', datafield: 'ReceivedBy', width: '10%', editable: true, hidden: true },
      ];
      let ouIdCombo = this.ouIdComboAddapter && this.ouIdComboAddapter.records ? this.ouIdComboAddapter.records : [{ Label: "", Value: "" }];
    this.Gridsource =
    {
      datatype: 'json',
      datafields: [
        { name: 'TransID', type: 'int' },
        { name: 'Inc', type: 'int' },
        { name: 'AssetTypeIDName', value: 'AssetTypeIDId', values: { source: ouIdCombo, value: 'Value', name: 'Label' } },
        { name: 'AssetTypeID', type: 'int' },
        { name: 'Brand', type: 'string' },
        { name: 'AssetNumber', type: 'string' },
        { name: 'IssuedDate', type: 'date' },
        { name: 'IssuedBy', type: 'int' },
        { name: 'HandedOver', type: 'date' },
        { name: 'ReceivedBy', type: 'int' },
        { name: 'ReceivedByName', type: 'string' },
        { name: 'IssuedByName', type: 'string' },
      ],
      id: 'invid',
      localdata: [
        {
          "TransID": 0,
          "Inc": 0,
          "AssetTypeID": 0,
          "IssuedBy": 0,
          "ReceivedBy": 0
        }
      ]
    };
    this.GridAdapter = new $.jqx.dataAdapter(this.Gridsource);
    this.GridToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'commodityAdd',
          delete: 'commodityDelete',
        }

        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.invoiceGrid,
          toolbarObj: toolbar,
          buttonObj: buttonIdObj,
          gridTitle: "",
          addRowMethodObj: this.addGridNewRow,
          deleteRowMethodObj: this.deleteRowCommodityGrid,
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }
  }

  addGridNewRow(obj) {
    // var containerGridRows = $('.invoiceGrid').jqxGrid('getrows');
    // let INC = 0;
    // containerGridRows.forEach(element => {
    //   INC = INC + 1;
    // });
    //   let invoiceGridMondatoryValidation = obj.gridService.checkGridMondatory(".invoiceGrid", ['AssetTypeID']);
    //   if (invoiceGridMondatoryValidation) {
        let row = {};
        row['TransID'] = 0
        row['Inc'] = 0
        row['AssetTypeID'] = 0
        row['IssuedBy'] = 0
        row['ReceivedBy'] = 0
        return row;
      // }
  
    
  }
  deleteRowCommodityGrid(obj) {
    let selectedrowindex = obj.invoiceGrid.getselectedrowindex();
    let selectedrowindexes = obj.invoiceGrid.getselectedrowindexes();
    let rowscount = obj.invoiceGrid.getdatainformation().rowscount;
    if (selectedrowindexes.length > 0) {
      if (Number(rowscount) > 0) {
        let deleteRows: any = [];
        selectedrowindexes.forEach(index => {
          let id = obj.invoiceGrid.getcellvalue(selectedrowindex, 'TransID')
          if (id) {
            var rowData = obj.invoiceGrid.getrowdata(index)
            rowData.isActive = 0;
            obj.deletedGridRowList.push(rowData);
            let rowId = obj.invoiceGrid.getrowid(index);
            deleteRows.push(rowId);
          } else {
            let rowId = obj.invoiceGrid.getrowid(index);
            deleteRows.push(rowId);
          }
        });
        if (deleteRows.length > 0) {
          obj.invoiceGrid.deleterow(deleteRows);
          if (!$(".invoiceGrid").jqxGrid('getrows').length) {
            $(".invoiceGrid").jqxGrid("clear");
            $(".invoiceGrid").jqxGrid("addrow", 0, obj.addGridNewRow(obj));
          }
        }
      }
    } else {
      obj.alert.openSnackBar("No row selected", '');
    }
  }

  GetAssetType() {
    return new Promise((resolve, reject) => {
      let OuIds: any[] = [];
      this.http.get(this.WebAPImasteruri + '/item-activity/combo?value=ASSET TYPE').subscribe(
        value => {
          OuIds = (value as any).result.Table as any[];
          let oucomboSource: any =
          {
            datatype: 'json',
            datafields: [
              { name: 'Label', type: 'string' },
              { name: 'Value', type: 'string' }
            ],
            localdata: OuIds
          };
          this.ouIdComboAddapter = new jqx.dataAdapter(oucomboSource, { autoBind: true });
          resolve(this.ouIdComboAddapter);

        });
    });
  }

  Save() {
    let invoiceFinalGridRows: Array<any> = [];
    var frmObj = this.EmployeeForm.getRawValue();
    frmObj.OuCode = this.property.OuCode;
    frmObj.isActive = 1;
    frmObj.UpdatedBy = this.property.userId;
    if (!frmObj.EmployeeID) {
      delete frmObj.EmployeeID;
      frmObj.CreatedBy = this.property.userId;
    }
    if (!frmObj.EmpCode) {
      delete frmObj.EmpCode;
    }
   let inc=1;
    var invoiceGridRows = $('.invoiceGrid').jqxGrid('getrows');
    invoiceGridRows.forEach(element => {
      element.isActive = 1;
      if (!element.TransID) {
        delete element.TransID;
        element.CreatedBy = this.property.userId;
      }else{
        element.UpdatedBy = this.property.userId;
      }
     
      element.EmployeeID = frmObj.EmployeeID;
      element.EmployeeNo = frmObj.EmpCode;
      if (!element.AssetTypeID) {
        delete element.AssetTypeID;
      }
      if (!element.Brand) {
        delete element.Brand;
      }
      if (!element.AssetNumber) {
        delete element.AssetNumber;
      }
      if (!element.IssuedBy) {
        delete element.IssuedBy;
      }
      if (!element.ReceivedBy) {
        delete element.ReceivedBy;
      }
     
      if (!element.IssuedDate) {
        delete element.IssuedDate;
      } else {
        element.IssuedDate = this.datePipe.transform(element.IssuedDate, 'MM-dd-yyyy');
      }
      
      if (!element.HandedOver) {
        delete element.HandedOver;
      } else {
        element.HandedOver = this.datePipe.transform(element.HandedOver, 'MM-dd-yyyy');
      }
      element.Inc = inc;
      
     
     
      this.httpRequestService.postBSS(this.WebAPImasteruri + "/Asset/Update_Asset", element).then((response: any) => {

        if (response.status == 200) {
          if (response.result.Table[0].Number) {
            this.alert.openSnackBar(response.result.Table[0].Message + ' ' + response.result.Table[0].Number, '1');
          } else {
            this.alert.openSnackBar(response.result.Table[0].Message, '1');
          }
          this.Clear();
        } else if (response.status == 400) {
          this.alert.openSnackBar(response.result, '');
        }
      }, (error: any) => {
      });

      inc++;
    });

    this.deletedGridRowList.forEach(element => {
      element.isActive = 0;
      if (!element.TransID) {
        delete element.TransID;
        element.CreatedBy = this.property.userId;
      }else{
        element.UpdatedBy = this.property.userId;
      }
     
      element.EmployeeID = frmObj.EmployeeID;
      element.EmployeeNo = frmObj.EmpCode;
      if (!element.AssetTypeID) {
        delete element.AssetTypeID;
      }
      if (!element.Brand) {
        delete element.Brand;
      }
      if (!element.AssetNumber) {
        delete element.AssetNumber;
      }
      if (!element.IssuedBy) {
        delete element.IssuedBy;
      }
      if (!element.ReceivedBy) {
        delete element.ReceivedBy;
      }
     
      if (!element.IssuedDate) {
        delete element.IssuedDate;
      } else {
        element.IssuedDate = this.datePipe.transform(element.IssuedDate, 'MM-dd-yyyy');
      }
      
      if (!element.HandedOver) {
        delete element.HandedOver;
      } else {
        element.HandedOver = this.datePipe.transform(element.HandedOver, 'MM-dd-yyyy');
      }
      element.Inc = inc;
      
     
     
      this.httpRequestService.postBSS(this.WebAPImasteruri + "/Asset/Update_Asset", element).then((response: any) => {

        if (response.status == 200) {
          if (response.result.Table[0].Number) {
            this.alert.openSnackBar(response.result.Table[0].Message + ' ' + response.result.Table[0].Number, '1');
          } else {
            this.alert.openSnackBar(response.result.Table[0].Message, '1');
          }
          this.Clear();
        } else if (response.status == 400) {
          this.alert.openSnackBar(response.result, '');
        }
      }, (error: any) => {
      });

      inc++;
    });
    
  }

  Clear() {
    this.EmployeeForm.reset();
    this.EmployeeForm.enable();
    $(".invoiceGrid").jqxGrid('clear');
    this.GridInit();
    $(".invoiceGrid").jqxGrid({ disabled: false });
  }


 }
 